import { useAuth } from "../../auth/context";
import Api from "../../apis/api";

export default (token) => {
  const { accessToken } = useAuth() || {};
  return new Api(token || accessToken);
};